var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoSearch = function SvgNoSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    viewBox: "0 0 44 44",
    "aria-hidden": "true",
    focusable: "false",
    className: "Icon_svg__1DbD3 Icon_large__1ZCQU",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M25.987 28.408l2.594-2.594 8.393 8.394-2.593 2.594-8.394-8.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M25.987 28.408l2.594-2.594 8.393 8.394-2.593 2.594-8.394-8.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M25.987 28.408l2.594-2.594 8.393 8.394-2.593 2.594-8.394-8.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M24.997 27.795l2.97-2.97.802.8-2.97 2.972-.802-.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M24.997 27.795l2.97-2.97.802.8-2.97 2.972-.802-.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M34.192 36.99l2.971-2.97.802.801-2.971 2.971-.802-.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear)",
    d: "M34.192 36.99l2.971-2.97.802.801-2.971 2.971-.802-.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear)",
    d: "M24.808 24.871c-4.01 4.011-10.514 4.011-14.524 0-4.011-4.01-4.011-10.513 0-14.524 4.01-4.011 10.513-4.011 14.524 0 4.01 4.01 4.01 10.513 0 14.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear)",
    d: "M24.336 24.4c-4.01 4.01-10.513 4.01-14.524 0-4.01-4.011-4.01-10.514 0-14.525 4.01-4.01 10.514-4.01 14.524 0 4.011 4.011 4.011 10.514 0 14.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear)",
    d: "M24.336 24.4c-4.01 4.01-10.513 4.01-14.524 0-4.01-4.011-4.01-10.514 0-14.525 4.01-4.01 10.514-4.01 14.524 0 4.011 4.011 4.011 10.514 0 14.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear)",
    d: "M22.875 22.938a8.203 8.203 0 11-11.601-11.601 8.203 8.203 0 0111.6 11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear)",
    d: "M22.875 22.938a8.203 8.203 0 11-11.601-11.601 8.203 8.203 0 0111.6 11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear)",
    d: "M9.812 9.875c-4.01 4.011-4.01 10.514 0 14.525 4.01 4.01 10.514 4.01 14.524 0 4.011-4.011 4.011-10.514 0-14.525-4.01-4.01-10.513-4.01-14.524 0zm1.462 1.462a8.203 8.203 0 1111.6 11.6 8.203 8.203 0 01-11.6-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear)",
    d: "M11.274 11.337a8.203 8.203 0 1011.6 11.6 8.203 8.203 0 00-11.6-11.6zm.283.283a7.803 7.803 0 1111.035 11.035A7.803 7.803 0 0111.557 11.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear)",
    d: "M23.865 25.06l1.368-1.368a.2.2 0 01.282.283l-1.367 1.368a.2.2 0 01-.283-.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear)",
    d: "M23.818 25.107l1.462-1.462 1.933 1.934-1.462 1.462-1.933-1.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear)",
    d: "M23.818 25.107l1.462-1.462 1.933 1.934-1.462 1.462-1.933-1.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear)",
    d: "M23.818 25.107l1.462-1.462 1.933 1.934-1.462 1.462-1.933-1.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M17.612 11.345l1.572-.421a.787.787 0 01.407 1.52l-1.572.42a.787.787 0 01-.407-1.52zM17.882 13.632l3.053-.818a.787.787 0 11.408 1.52l-3.054.818a.787.787 0 11-.407-1.52zM12.394 12.743l.864-.231a.787.787 0 01.407 1.52l-.864.231a.787.787 0 01-.407-1.52zM11.633 15.307l4.085-1.095a.787.787 0 01.407 1.52l-4.085 1.095a.787.787 0 01-.407-1.52zM15.421 11.932l.027-.007a.787.787 0 11.407 1.52l-.026.007a.787.787 0 01-.408-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear)",
    fillRule: "evenodd",
    d: "M4.173 10.447c.234 0 .463.096.63.26.164.167.26.396.26.63a.904.904 0 01-.396.739 1.009 1.009 0 01-.32.131.896.896 0 01-.802-.242.903.903 0 01-.26-.629c0-.233.095-.462.26-.629a.903.903 0 01.628-.26zm0-6.888A2.559 2.559 0 016.73 6.114 2.56 2.56 0 015.062 8.51v.382a.889.889 0 01-1.778 0V7.78c0-.491.399-.89.89-.89a.779.779 0 000-1.554.779.779 0 00-.778.777.889.889 0 01-1.778 0A2.559 2.559 0 014.173 3.56z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear)",
    fillRule: "evenodd",
    d: "M4.173 10.447c.234 0 .463.096.63.26.164.167.26.396.26.63a.904.904 0 01-.396.739 1.009 1.009 0 01-.32.131.896.896 0 01-.802-.242.903.903 0 01-.26-.629c0-.233.095-.462.26-.629a.903.903 0 01.628-.26zm0-6.888A2.559 2.559 0 016.73 6.114 2.56 2.56 0 015.062 8.51v.382a.889.889 0 01-1.778 0V7.78c0-.491.399-.89.89-.89a.779.779 0 000-1.554.779.779 0 00-.778.777.889.889 0 01-1.778 0A2.559 2.559 0 014.173 3.56z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear)",
    fillRule: "evenodd",
    d: "M4.173 10.447c.234 0 .463.096.63.26.164.167.26.396.26.63a.904.904 0 01-.396.739 1.009 1.009 0 01-.32.131.896.896 0 01-.802-.242.903.903 0 01-.26-.629c0-.233.095-.462.26-.629a.903.903 0 01.628-.26zm0-6.888A2.559 2.559 0 016.73 6.114 2.56 2.56 0 015.062 8.51v.382a.889.889 0 01-1.778 0V7.78c0-.491.399-.89.89-.89a.779.779 0 000-1.554.779.779 0 00-.778.777.889.889 0 01-1.778 0A2.559 2.559 0 014.173 3.56z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear)",
    fillRule: "evenodd",
    d: "M4.173 10.447c.234 0 .463.096.63.26.164.167.26.396.26.63a.904.904 0 01-.396.739 1.009 1.009 0 01-.32.131.896.896 0 01-.802-.242.903.903 0 01-.26-.629c0-.233.095-.462.26-.629a.903.903 0 01.628-.26zm0-6.888A2.559 2.559 0 016.73 6.114 2.56 2.56 0 015.062 8.51v.382a.889.889 0 01-1.778 0V7.78c0-.491.399-.89.89-.89a.779.779 0 000-1.554.779.779 0 00-.778.777.889.889 0 01-1.778 0A2.559 2.559 0 014.173 3.56z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear)",
    fillRule: "evenodd",
    d: "M11.291 35.667c.529 0 1.047.216 1.425.59.372.377.59.895.59 1.424a2.05 2.05 0 01-.59 1.425c-.096.09-.196.176-.307.252-.11.07-.227.13-.347.18-.121.051-.247.092-.378.117a2.03 2.03 0 01-1.818-.549 2.046 2.046 0 01-.59-1.425c0-.529.217-1.047.59-1.425.377-.373.896-.589 1.425-.589zm0-15.608a5.797 5.797 0 015.791 5.79 5.8 5.8 0 01-3.777 5.429v.865a2.014 2.014 0 01-4.028 0v-2.518c0-1.112.902-2.014 2.014-2.014.972 0 1.763-.79 1.763-1.762s-.791-1.762-1.763-1.762c-.972 0-1.762.79-1.762 1.762a2.014 2.014 0 01-4.029 0 5.797 5.797 0 015.791-5.79z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear)",
    fillRule: "evenodd",
    d: "M11.291 35.667c.529 0 1.047.216 1.425.59.372.377.59.895.59 1.424a2.05 2.05 0 01-.59 1.425c-.096.09-.196.176-.307.252-.11.07-.227.13-.347.18-.121.051-.247.092-.378.117a2.03 2.03 0 01-1.818-.549 2.046 2.046 0 01-.59-1.425c0-.529.217-1.047.59-1.425.377-.373.896-.589 1.425-.589zm0-15.608a5.797 5.797 0 015.791 5.79 5.8 5.8 0 01-3.777 5.429v.865a2.014 2.014 0 01-4.028 0v-2.518c0-1.112.902-2.014 2.014-2.014.972 0 1.763-.79 1.763-1.762s-.791-1.762-1.763-1.762c-.972 0-1.762.79-1.762 1.762a2.014 2.014 0 01-4.029 0 5.797 5.797 0 015.791-5.79z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear)",
    fillRule: "evenodd",
    d: "M11.291 35.667c.529 0 1.047.216 1.425.59.372.377.59.895.59 1.424a2.05 2.05 0 01-.59 1.425c-.096.09-.196.176-.307.252-.11.07-.227.13-.347.18-.121.051-.247.092-.378.117a2.03 2.03 0 01-1.818-.549 2.046 2.046 0 01-.59-1.425c0-.529.217-1.047.59-1.425.377-.373.896-.589 1.425-.589zm0-15.608a5.797 5.797 0 015.791 5.79 5.8 5.8 0 01-3.777 5.429v.865a2.014 2.014 0 01-4.028 0v-2.518c0-1.112.902-2.014 2.014-2.014.972 0 1.763-.79 1.763-1.762s-.791-1.762-1.763-1.762c-.972 0-1.762.79-1.762 1.762a2.014 2.014 0 01-4.029 0 5.797 5.797 0 015.791-5.79z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear)",
    fillRule: "evenodd",
    d: "M11.291 35.667c.529 0 1.047.216 1.425.59.372.377.59.895.59 1.424a2.05 2.05 0 01-.59 1.425c-.096.09-.196.176-.307.252-.11.07-.227.13-.347.18-.121.051-.247.092-.378.117a2.03 2.03 0 01-1.818-.549 2.046 2.046 0 01-.59-1.425c0-.529.217-1.047.59-1.425.377-.373.896-.589 1.425-.589zm0-15.608a5.797 5.797 0 015.791 5.79 5.8 5.8 0 01-3.777 5.429v.865a2.014 2.014 0 01-4.028 0v-2.518c0-1.112.902-2.014 2.014-2.014.972 0 1.763-.79 1.763-1.762s-.791-1.762-1.763-1.762c-.972 0-1.762.79-1.762 1.762a2.014 2.014 0 01-4.029 0 5.797 5.797 0 015.791-5.79z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear)",
    fillRule: "evenodd",
    d: "M29.797 10.551c.357 0 .708.146.963.398.252.256.399.606.399.964 0 .357-.147.707-.399.963a1.717 1.717 0 01-.207.17 1.549 1.549 0 01-.235.122 1.307 1.307 0 01-.521.106c-.36 0-.711-.146-.963-.398a1.383 1.383 0 01-.399-.963c0-.358.147-.708.399-.964.255-.252.606-.398.963-.398zm0-10.551a3.919 3.919 0 013.915 3.914 3.921 3.921 0 01-2.553 3.67v.585a1.362 1.362 0 01-2.724 0V6.467c0-.752.61-1.362 1.362-1.362.657 0 1.191-.534 1.191-1.19 0-.658-.534-1.192-1.191-1.192s-1.191.534-1.191 1.191a1.362 1.362 0 01-2.724 0A3.919 3.919 0 0129.797 0z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear)",
    fillRule: "evenodd",
    d: "M29.797 10.551c.357 0 .708.146.963.398.252.256.399.606.399.964 0 .357-.147.707-.399.963a1.717 1.717 0 01-.207.17 1.549 1.549 0 01-.235.122 1.307 1.307 0 01-.521.106c-.36 0-.711-.146-.963-.398a1.383 1.383 0 01-.399-.963c0-.358.147-.708.399-.964.255-.252.606-.398.963-.398zm0-10.551a3.919 3.919 0 013.915 3.914 3.921 3.921 0 01-2.553 3.67v.585a1.362 1.362 0 01-2.724 0V6.467c0-.752.61-1.362 1.362-1.362.657 0 1.191-.534 1.191-1.19 0-.658-.534-1.192-1.191-1.192s-1.191.534-1.191 1.191a1.362 1.362 0 01-2.724 0A3.919 3.919 0 0129.797 0z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear)",
    fillRule: "evenodd",
    d: "M29.797 10.551c.357 0 .708.146.963.398.252.256.399.606.399.964 0 .357-.147.707-.399.963a1.717 1.717 0 01-.207.17 1.549 1.549 0 01-.235.122 1.307 1.307 0 01-.521.106c-.36 0-.711-.146-.963-.398a1.383 1.383 0 01-.399-.963c0-.358.147-.708.399-.964.255-.252.606-.398.963-.398zm0-10.551a3.919 3.919 0 013.915 3.914 3.921 3.921 0 01-2.553 3.67v.585a1.362 1.362 0 01-2.724 0V6.467c0-.752.61-1.362 1.362-1.362.657 0 1.191-.534 1.191-1.19 0-.658-.534-1.192-1.191-1.192s-1.191.534-1.191 1.191a1.362 1.362 0 01-2.724 0A3.919 3.919 0 0129.797 0z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear)",
    fillRule: "evenodd",
    d: "M29.797 10.551c.357 0 .708.146.963.398.252.256.399.606.399.964 0 .357-.147.707-.399.963a1.717 1.717 0 01-.207.17 1.549 1.549 0 01-.235.122 1.307 1.307 0 01-.521.106c-.36 0-.711-.146-.963-.398a1.383 1.383 0 01-.399-.963c0-.358.147-.708.399-.964.255-.252.606-.398.963-.398zm0-10.551a3.919 3.919 0 013.915 3.914 3.921 3.921 0 01-2.553 3.67v.585a1.362 1.362 0 01-2.724 0V6.467c0-.752.61-1.362 1.362-1.362.657 0 1.191-.534 1.191-1.19 0-.658-.534-1.192-1.191-1.192s-1.191.534-1.191 1.191a1.362 1.362 0 01-2.724 0A3.919 3.919 0 0129.797 0z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.596,
    x2: 35.678,
    y1: 24.424,
    y2: 35.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDD95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5C34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 28.123,
    x2: 27.107,
    y1: 27.95,
    y2: 26.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FCC758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.445,
    x2: 29.603,
    y1: 31.739,
    y2: 32.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB8140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 27.824,
    x2: 26.482,
    y1: 27.651,
    y2: 26.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDD95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5C34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 26.014,
    x2: 25.049,
    y1: 27.521,
    y2: 28.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB8140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 34.547,
    x2: 36.479,
    y1: 34.375,
    y2: 36.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDD95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5C34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 35.21,
    x2: 34.245,
    y1: 36.717,
    y2: 37.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB8140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 21.633,
    x2: 25.773,
    y1: 21.696,
    y2: 25.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 24.336,
    x2: 22.535,
    y1: 24.4,
    y2: 22.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505C70",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 9.812,
    x2: 10.845,
    y1: 9.875,
    y2: 10.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849BBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C879A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 11.274,
    x2: 22.447,
    y1: 11.337,
    y2: 23.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 13.458,
    x2: 11.274,
    y1: 13.521,
    y2: 11.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 14.268,
    x2: 24.336,
    y1: 14.331,
    y2: 24.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E5A6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 17.053,
    x2: 16.914,
    y1: 25.332,
    y2: 12.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E5A6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 24.549,
    x2: 24.832,
    y1: 24.376,
    y2: 24.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44536B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 25.168,
    x2: 24.54,
    y1: 25.69,
    y2: 26.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61718D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37445A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 24.549,
    x2: 25.779,
    y1: 24.376,
    y2: 25.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525E72",
    stopOpacity: 0.345
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 26.482,
    x2: 26.283,
    y1: 26.309,
    y2: 26.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323B4A",
    stopOpacity: 0.687
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505C70",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 4.173,
    x2: 4.173,
    y1: 2.812,
    y2: 12.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74829A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 4.173,
    x2: 4.173,
    y1: 11.252,
    y2: 12.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C687B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 4.173,
    x2: 5.009,
    y1: 7.63,
    y2: 8.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7A8D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525E72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 4.331,
    x2: 2.8,
    y1: 10.484,
    y2: 4.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 11.291,
    x2: 11.291,
    y1: 18.367,
    y2: 39.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74829A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 11.291,
    x2: 11.291,
    y1: 37.491,
    y2: 39.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C687B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 11.291,
    x2: 13.185,
    y1: 29.284,
    y2: 31.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7A8D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525E72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 11.647,
    x2: 8.179,
    y1: 35.75,
    y2: 21.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 29.797,
    x2: 29.797,
    y1: -1.143,
    y2: 13.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74829A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 29.797,
    x2: 29.797,
    y1: 11.784,
    y2: 13.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F7D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C687B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 29.797,
    x2: 31.077,
    y1: 6.236,
    y2: 7.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7A8D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525E72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 30.038,
    x2: 27.693,
    y1: 10.607,
    y2: 0.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDBEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H44V44H0z",
    transform: "matrix(-1 0 0 1 44 0)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoSearch);
export { ForwardRef as ReactComponent };